module.exports = __webpack_public_path__ + "static/media/towers.00636100.png";